import React, { useEffect } from 'react';
import PowerUp from './components/PowerUp';

function App() {
  useEffect(() => {
    window.TrelloPowerUp.initialize({
      'board-buttons': function(t, options) {
        return [{
          icon: {
            dark: 'https://trello-report.netlify.app/logo512.png',
            light: 'https://trello-report.netlify.app/logo512.png'
          },
          text: 'AI Reports',
          callback: function(t) {
            return t.popup({
              title: 'AI Report Generator',
              url: t.signUrl('./index.html'),
              width: 380, // Increased width for better UI
              height: 480, // Increased height for footer
            });
          }
        }];
      }
    });
  }, []);

  return (
    <div className="App">
      <PowerUp />
    </div>
  );
}

export default App;